<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title ">{{$t('My agreements')}}</h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content m-content-ls">
        <div class="m-portlet m-portlet--full-height  ">
          <div class="tab-content">
            <div class="">
              <div class="m-form m-form--fit m-form--label-align-right">
                <div class="m-portlet__body pb-0">
                  <div v-if="isSelfRegistered" class="form-group m-form__group row">
                    <label class="col-2 label-switch">
                      <switches v-model="requiredAgreement"
                                v-b-tooltip.hover.left
                                @input="$root.$emit('bv::hide::tooltip')"
                                :title="requiredAgreement ? $t('Agreement granted') : $t('No agreement granted')"
                                :color="requiredAgreement ? 'green' : 'default'"></switches>
                    </label>
                    <div class="col-10 d-flex">
                      <span class="mr-2">*</span>
                      <required-agreement :open-in-modal="false"></required-agreement>
                    </div>
                  </div>

                  <div v-for="agreement in agreements" :key="agreement.number" class="form-group m-form__group row">
                    <label class="col-2 label-switch">
                      <switches v-model="agreement.enabled"
                                v-b-tooltip.hover.left
                                @input="$root.$emit('bv::hide::tooltip')"
                                :title="agreement.enabled ? $t('Agreement granted') : $t('No agreement granted')"
                                :color="agreement.enabled ? 'green' : 'default'"></switches>
                    </label>
                    <div class="col-10 d-flex">
                      <span v-if="agreement.required === true || agreement.required === '1'" class="mr-2">*</span>
                      <agreement-text :agreement="agreement"/>
                    </div>
                  </div>
                  <div class="mt-5 m-form__seperator m-form__seperator--dashed m-form__seperator--space"></div>
                  <div class="required-field-container">
                    {{$t('* - Agreement required')}}
                  </div>
                  <div class="m-portlet__foot m-portlet__foot--fit">
                    <div class="m-form__actions">
                      <div class="row">
                        <div class="col-12">
                          <button type="reset" class="btn m-btn m-btn--air btn-ls"
                                  @click="updateAgreements">
                            {{ $t('Save changes') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <delete-account-password-prompt-modal ref="passwordPrompt" agreement></delete-account-password-prompt-modal>
  </page>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Switches from 'vue-switches';
import Encode from '@/directives/encode'
import Page from "./Page";
import RequiredAgreement from "../agreements/RequiredAgreement";
import PageModal from "../modal/PageModal";
import DeleteAccountPasswordPromptModal from "../modal/DeleteAccountPasswordPromptModal";
import AgreementText from "@/components/agreements/AgreementText";

export default {
    name: "AgreementsPage",
    components: {
      AgreementText,
      DeleteAccountPasswordPromptModal,
      PageModal,
      RequiredAgreement,
      Page,
      Switches,
    },
    directives: {
      Encode
    },
    data() {
      return {
        requiredAgreement: true,
        agreements: []
      }
    },
    updated() {
      if (!this.agreements.length && !this.isSelfRegistered) {
        this.pushToFirstPage();
      }
    },
    mounted() {
      //fill form immediately
      this.cloneAgreementsFormState();

      //update form after fetch
      this.fetchAgreements()
        .then(() => this.cloneAgreementsFormState());
    },
    methods: {
      ...mapActions([
        'setAgreements',
        'fetchAgreements',
        'fetchUser',
        'pushToFirstPage'
      ]),
      cloneAgreementsFormState() {
        this.agreements = JSON.parse(JSON.stringify(this.stateAgreements))
      },
      updateAgreements() {
        if (!this.requiredAgreement) {
          this.$refs.passwordPrompt.show();

          return;
        }

        this.$http.patch('agreements', this.agreements)
            .then((r) => {
              if (r.data.success) {
                this.setAgreements(r.data.agreements)
              }
            })
            .then(() => this.fetchUser())
            .then(() => {
              if (this.isAnyFieldMissing && this.missingAgreements.length === 0) {
                this.$router.push({name: 'ProfilePage'});
              }
            });
      },
    },
    computed: {
      ...mapState({
        stateAgreements: state => state.auth.agreements,
        isSelfRegistered: state => state.auth.user.self_registered,
        missingAgreements: state => state.auth.user.missing_agreements,
        isAnyFieldMissing: state => state.auth.user.missing_fields.length > 0,
      }),
      isPasswordError() {
        return !!this.passwordError.length
      }
    }
  }
</script>

<style>
  .label-switch {
    text-align: right;
  }

  .label-switch input[type=checkbox] {
    display: none;
  }

  .bold {
    font-weight: 500 !important;
  }
</style>
